import React from 'react';
import { AccessibleDivButton, BackButton, PageTitleHelmet } from '@/components';
import { useGoogleTranslator, useNavigationPreviousPage } from '@/hooks';
import { BodyLargeEmphasized } from '../Typography';
import styles from './NavBar.styles';

interface Props {
  trackId: string;
  children: React.ReactNode;
  onClickBackButton?: () => void;
}

export const NavBarBackButton: React.FC<Props> = ({ trackId, children, onClickBackButton }) => {
  const navigatePreviousPage = useNavigationPreviousPage();
  const titleTranslated = useGoogleTranslator(children as string);
  return (
    <header className={styles.container} data-testid="navbar">
      <PageTitleHelmet>{children}</PageTitleHelmet>
      <div className={styles.backButtonPosition}>
        <BackButton trackId={trackId} size={24} onClick={onClickBackButton} />
      </div>
      <BodyLargeEmphasized data-testid="pageName" as="h1">
        {titleTranslated}
      </BodyLargeEmphasized>
    </header>
  );
};
